import axios, { AxiosRequestConfig } from 'axios';
import { getPassword } from './storageHelper';

export class AxiosHelper {
  static password: string;
  static baseUrl: string | null = null;

  static setUpAxios(password: string) {
    AxiosHelper.password = password;
    if (window.location.port === '3000') {
      this.baseUrl = 'http://localhost:5000';
    }
  }

  static async getWithAxios(url: string, params?: AxiosRequestConfig<any>) {
    AxiosHelper.validateAxios();
    const axiosParams = AxiosHelper.attachAuth(params);
    if (this.baseUrl) {
      url = `${this.baseUrl}${url}`;
    }
    return axios.get(url, axiosParams);
  }

  static async postWithAxios(url: string, data?: any, params?: AxiosRequestConfig<any>) {
    AxiosHelper.validateAxios();
    const axiosParams = AxiosHelper.attachAuth(params);
    if (this.baseUrl) {
      url = `${this.baseUrl}${url}`;
    }
    return axios.post(url, data, axiosParams);
  }
  static async patchWithAxios(url: string, data?: any, params?: AxiosRequestConfig<any>) {
    AxiosHelper.validateAxios();
    const axiosParams = AxiosHelper.attachAuth(params);
    if (this.baseUrl) {
      url = `${this.baseUrl}${url}`;
    }
    return axios.patch(url, data, axiosParams);
  }

  static async deleteWithAxios(url: string, params?: AxiosRequestConfig<any>) {
    AxiosHelper.validateAxios();
    const axiosParams = AxiosHelper.attachAuth(params);
    if (this.baseUrl) {
      url = `${this.baseUrl}${url}`;
    }
    return axios.delete(url, axiosParams);
  }

  private static validateAxios() {
    if (!AxiosHelper.password) {
      const password = getPassword();
      if (password) {
        AxiosHelper.setUpAxios(password);
      } else {
        console.error('Axios client not set up with password.');
        window.location.replace('/login');
      }
    }
  }

  private static attachAuth(params?: AxiosRequestConfig<any>) {
    return { ...params, headers: { ...(params?.headers || {}), password: AxiosHelper.password } };
  }
}
